module.exports = __webpack_public_path__ + "static/media/RakbankLogo.11a1f369.svg";